const timesRefresh =
  typeof process.env.VUE_APP_TIMES_REFRESH === 'string'
    ? parseInt(process.env.VUE_APP_TIMES_REFRESH) || 30000 // five minutes
    : process.env.VUE_APP_TIMES_REFRESH || 30000; // five minutes

export enum RefreshTime {
  TIMES = timesRefresh,
}
